import { create } from "zustand"
import { useRef, useEffect } from 'react'
import { Modal } from 'bootstrap'

import { MSG_TERMINATE_DISCLAIMER_LINES } from "../../constants"



interface ApplicationTerminateDisclaimerDialogState {
  show: boolean,
  toggleShow: (show: boolean) => void
}

export const useApplicationTerminateDisclaimerDialogState = create<ApplicationTerminateDisclaimerDialogState>()((set, get) => ({
  show: false, 
  toggleShow: (show: boolean) => { set({show});},
}));


export const ApplicationTerminateDisclaimerDialog =  () => {
        
  const modalRef = useRef<HTMLDivElement | null>(null);
  const { show, toggleShow} = useApplicationTerminateDisclaimerDialogState(state => state);

  useEffect(() => {
    if (! (modalRef && modalRef.current)) return;
  
    const modalEle = modalRef.current;    
    if (show) {
      const bsModal = new Modal(modalEle, {
        backdrop: false,
        keyboard: false
      })
      bsModal.show();
      return;                
    } 
    const bsModal= Modal.getInstance(modalEle)
    if (bsModal) bsModal.hide();       
  // eslint-disable-next-line          
  }, [show, modalRef]);

  return (
  <div className="modal" ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered min-w-600px">
      <div className="modal-content">
    
        <div className="modal-header">
          <div>
            <h2 className="modal-title text-danger fs-5" id="staticBackdropLabel">DISCLAIMER</h2>
          </div>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => toggleShow(false)}></button>
        </div>

        <div className="modal-body">
          <div className="rounded border border-danger border-opacity-75 p-4 mb-4">
            <div className="d-flex flex-column gap-3 fs-7">
            { MSG_TERMINATE_DISCLAIMER_LINES.map( (txt: string, idx:number) => (
              <div key={`idx${idx}`}>{txt}</div>
            ))}
            </div>
          </div>              
        </div>

        <div className="modal-footer">
          <button
              type='button'
              onClick={()=> { toggleShow(false)}}
              className='btn btn-sm btn-primary'
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
  )
};